import React, { useState, useEffect, useMemo, useContext } from 'react';
import DialogComp from '../../../../Core/Modal/dialogModal';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ManageAccountGrid from '../../../managementAccount/manageAccountGrid/index';
import ExpenseCodeGroupsModal from './ExpenseCodeGroupsModal';
import { Grid } from '@material-ui/core';
import ReactDOM from 'react-dom';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Management Accounts', active: true },
    { name: 'Expense Code', active: true }
];
const basecolumns = [
    { field: 'expenseCode', title: 'Expense Code', width: 120 },
    { field: 'kerridgeDesc', title: 'Description' },
    { field: 'maExpenseDescription', title: 'Management Account Description' },
    { field: 'normalBalanceSign', title: 'Balance Sign', width: 120 },
    { field: 'accountType', title: 'Type', width: 120 },
    { field: 'divisionDescription', title: 'Division', width: 120 },
    { field: 'expenseGroup', title: 'Group', width: 120 },
    { field: 'shortName', title: 'Branch', width: 120 }
];
const MappingExpenseCode = () => {
    const [state, setState] = useState({
        showLoader: true,
        selectedRowData: {},
        selectedRecord: null,
        isPopupModal: false,
        isReload: '',
        selectedColumnName: ''
    });

    const openModal = (record, columnName) => {
        const [code, description] =
            columnName === 'expenseGroup' ? record.expenseGroup.split(/-(.+)/).map((s) => s.trim()) : [record.expenseCode, record.maExpenseDescription];

        const selectedRecord = {
            code,
            keyloopDesc: columnName === 'expenseCode' ? record.kerridgeDesc : record.kerridgeGroupDesc,
            description
        };

        setState((st) => ({
            ...st,
            isPopupModal: true,
            selectedRecord,
            selectedColumnName: columnName
        }));
    };

    const closeModal = (isReload) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.isPopupModal = false;
            newSt.selectedRecord = null;
            if (isReload) {
                newSt.isReload = new Date();
            }
            return newSt;
        });
    };

    const ExpenseCodeColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => openModal(record, 'expenseCode')}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const ExpenseGroupColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => openModal(record, 'expenseGroup')}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const columns = useMemo(() => {
        let col = [...basecolumns];
        let colAccCode = col.find((m) => m.field === 'expenseCode');
        if (colAccCode) {
            colAccCode.renderer = ExpenseCodeColumnWrapper;
        }
        let colAccGrpCode = col.find((m) => m.field === 'expenseGroup');
        if (colAccGrpCode) {
            colAccGrpCode.renderer = ExpenseGroupColumnWrapper;
        }
        return col;
    }, []);

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <ManageAccountGrid
                columns={columns}
                getUrl={`NominalExpenseCodes/ExpenseCodes_List`}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
            />
            {state.isPopupModal && (
                <DialogComp
                    title={`Update ${state.selectedColumnName === 'expenseCode' ? 'Expense Code' : 'Expense Group'} Description`}
                    onClose={() => closeModal(false)}
                    maxWidth="md"
                    fullWidth
                    overflow="auto"
                >
                    <ExpenseCodeGroupsModal selectedRecord={state.selectedRecord} selectedColumnName={state.selectedColumnName} onClose={closeModal} />
                </DialogComp>
            )}
        </div>
    );
};

export default MappingExpenseCode;
